import moment from 'moment';

export const isDaySame = (start, end) => moment(start).isSame(end, 'day');
